const photoBarUploadingFormEquip = {
  typography: 'Aguarde o arquivo subir'
};

export default photoBarUploadingFormEquip;
